import { render } from "./CreateNewPO.vue?vue&type=template&id=2a36399b&scoped=true"
import script from "./CreateNewPO.vue?vue&type=script&lang=js"
export * from "./CreateNewPO.vue?vue&type=script&lang=js"

import "./CreateNewPO.vue?vue&type=style&index=0&id=2a36399b&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a36399b"]])

export default __exports__